import hankakuZenkau from './hankaku-zenkau'
import hiraganaKatakana from './hiragana-katakana'
import urls from './urls'

// String
String.prototype.hankakuToZenkaku = function() {
    return hankakuZenkau.hankakuToZenkaku(this)
}
String.prototype.zenkakuToHankaku = function() {
    return hankakuZenkau.zenkakuToHankaku(this)
}
String.prototype.zenkanaToHankana = function() {
    return hankakuZenkau.zenkanaToHankana(this)
}
String.prototype.hankanaToZenkana = function() {
    return hankakuZenkau.hankanaToZenkana(this)
}
String.prototype.kanaToHira = function() {
    return hiraganaKatakana.kanaToHira(this)
}
String.prototype.hiraToKana = function() {
    return hiraganaKatakana.hiraToKana(this)
}
String.prototype.toKeyword = function() {
    return this
        .trim()
        .toLowerCase()
        .hiraToKana()
        .zenkanaToHankana()
        .replace(/ﾞ/g, '')
        .replace(/ﾟ/g, '')
}


// $helpers.xxx
const helpers = {
    ...hankakuZenkau,
    ...hiraganaKatakana,
    ...urls,
    toKeyword: val => val.toKeyword(),
    sleep: msec => new Promise(resolve => setTimeout(resolve, msec)),
}


export default {
    install(Vue) {
        Vue.prototype.$helpers = helpers
    }
}
